var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{staticClass:"menu",class:{
    'pl-12': _vm.isSubmenu,
    'isTitle': _vm.isTitle,
    'hidden': _vm.hidden
  },attrs:{"to":_vm.target,"link":!!_vm.to,"disabled":_vm.isTitle,"exact":"","exact-path":""},on:{"click":function($event){return _vm.onAction()}}},[(_vm.iconPrepend && _vm.icon)?_c('v-list-item-icon',{staticClass:"mr-2 icon-base"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1):_vm._e(),_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }